import { getLink } from '../api/resource';

export interface ViewStateUrlContext {
  context: string;
}

/**
 * Загрузка состояния из URL
 */
export const getViewStateFromUrl = async (): Promise<string | null> => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlState = urlParams.get('state');

  if (!urlState) return null;

  try {
    const response = await getLink(urlState);
    return response.data.context;
  } catch (error) {
    console.error('Ошибка при загрузке breadcrumbs по ссылке:', error);
    return null;
  }
};